import styled from 'styled-components';

export const WebMapContainer = styled.div`
  height: ${({ h }) => (h ? h : '400px')};
  width: ${({ w }) => (w ? w : '100%')};
  border: 1px solid ${({ theme }) => theme.mocaPurple};
`
